module.exports = __webpack_public_path__ + "south-africa.svg?81a39a30e10d3883a13a4c57bfae9db1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/south-africa.svg
// module id = 299
// module chunks = 10